import React from "react";
import {
	StepCircle,
	StepContainer,
	StepLineFirst,
	StepLineSecond,
	StepperContainer
} from "./styles";

const Stepper = ({ currentStep }) => {
	const steps = [1, 2, 3];

	return (
		<StepperContainer>
			<StepLineFirst active={currentStep >= 2} />

			<StepLineSecond active={currentStep >= 3} />

			{steps.map(step => (
				<StepContainer key={step}>
					<StepCircle active={currentStep >= step}>{step}</StepCircle>
				</StepContainer>
			))}
		</StepperContainer>
	);
};

export default Stepper;
